import React from 'react';

const AccountingMockup = () => {
  return (
    <div className="mockup-container accounting-mockup">
      <div className="mockup-header-bar">
        <div className="mockup-title">Contabilidad y Cierre de Caja</div>
        <div className="date-pill">Mayo 2026</div>
      </div>

      <div className="revenue-summary">
        <div className="rev-item">
          <span className="rev-label">Ingresos Totales</span>
          <span className="rev-val">€24,850.40</span>
          <span className="rev-trend positive">+8.2% vs abr</span>
        </div>
        <div className="rev-chart-mini">
          <div className="bar" style={{height: '30%'}}></div>
          <div className="bar" style={{height: '50%'}}></div>
          <div className="bar" style={{height: '45%'}}></div>
          <div className="bar" style={{height: '70%'}}></div>
          <div className="bar" style={{height: '60%'}}></div>
          <div className="bar active" style={{height: '90%'}}></div>
        </div>
      </div>

      <div className="cash-control-card">
        <div className="card-h">Estado de Cajas Actual</div>
        <div className="cash-row">
          <div className="cash-info">
            <span className="c-name">Caja Principal</span>
            <span className="c-status">Abierta (Staff: Ana)</span>
          </div>
          <span className="c-amount">€1,420.50</span>
        </div>
        <div className="cash-row">
          <div className="cash-info">
            <span className="c-name">Caja Cafetería</span>
            <span className="c-status">Cerrada hace 2h</span>
          </div>
          <span className="c-amount">€640.20</span>
        </div>
        <div className="action-row">
          <button className="btn-close-box">Cerrar Caja General</button>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .accounting-mockup { background: #fdfdfd; border: 1px solid #e5e7eb; border-radius: 12px; padding: 24px; display: flex; flex-direction: column; gap: 24px; }
        .mockup-header-bar { display: flex; justify-content: space-between; align-items: center; }
        .date-pill { font-size: 11px; font-weight: 600; padding: 4px 12px; background: #f3f4f6; border-radius: 99px; }
        
        .revenue-summary { display: flex; align-items: flex-end; gap: 32px; padding: 20px; background: #111827; border-radius: 12px; color: white; }
        .rev-item { flex: 1; display: flex; flex-direction: column; gap: 4px; }
        .rev-label { font-size: 11px; opacity: 0.6; }
        .rev-val { font-size: 24px; font-weight: 700; }
        .rev-trend { font-size: 10px; font-weight: 600; }
        .rev-trend.positive { color: #10b981; }
        
        .rev-chart-mini { display: flex; align-items: flex-end; gap: 4px; height: 50px; }
        .rev-chart-mini .bar { width: 8px; background: #374151; border-radius: 2px; }
        .rev-chart-mini .bar.active { background: #059669; box-shadow: 0 0 8px #10b981; }
        
        .cash-control-card { display: flex; flex-direction: column; gap: 12px; }
        .card-h { font-size: 12px; font-weight: 700; color: #111827; margin-bottom: 4px; }
        .cash-row { display: flex; justify-content: space-between; align-items: center; padding: 12px; background: white; border: 1px solid #f3f4f6; border-radius: 8px; }
        .cash-info { display: flex; flex-direction: column; }
        .c-name { font-size: 13px; font-weight: 600; }
        .c-status { font-size: 11px; color: #9ca3af; }
        .c-amount { font-weight: 700; color: #111827; }
        
        .action-row { margin-top: 8px; }
        .btn-close-box { width: 100%; padding: 10px; background: #f3f4f6; border: 1px solid #e5e7eb; border-radius: 8px; font-size: 12px; font-weight: 600; cursor: pointer; transition: background 0.2s; }
        .btn-close-box:hover { background: #e5e7eb; }
      `}} />
    </div>
  );
};

export default AccountingMockup;
